import { feedbackProcessingDialog, killProcessingDialog } from '../components/dialogs/dialog.module.js';
import { removeAllErrorToolTips, showErrorToolTips } from '../components/dialogs/errorhandle.dialog.js';
import { openPaymentDialog } from '../components/payment/braintree.js';
import { validate_decnum_orempty, validate_notEmptyString } from '../helpers/validators/validate.js';
import { httpRequest } from './_http.api.service.js';
import { wadialog } from '../components/dialogs/dialog.module.js';
import { createAlert } from './alerts.service.js';
import {registerCreateExtraAlertEvents} from '../components/alertDialogs/createSameAlert.dialog.events.js';
export function getAllPortfolioData() {
	return new Promise(function (resolve, reject) {
		$.get('/all_userportfoliodata', function (assets_arr) {
			if (assets_arr.success == false) {
				reject();
			} else {				
				var assets = 0;
				for (var item in assets_arr) {
					assets = assets_arr[item];
				}				
				/* clear userasset data */
				userassets = [];
				//userCurExRates = [];
				var i = 0;
				for (var item in assets) {
					if (assets[item].creditpoints !== undefined) {
						creditpoints.left = assets[item].creditpoints;
						creditpoints.currency = assets[item].currency;
						creditpoints.in_currency = assets[item].incurrency;
						creditpoints.accounttype = assets[item].accounttype;
						creditpoints.plan = assets[item].plan || (assets[item].accounttype === 'premium' ? 'unlimited' : 'free');
						creditpoints.canadditem = assets[item].canadditem;
						creditpoints.monthlycosts = assets[item].monthlycosts;
					} else if (assets[item].ratioEURToUserCur) {
						userCurExRates.ratioEURToUserCur = assets[item].ratioEURToUserCur;
						userCurExRates.ratioUSDToUserCur = assets[item].ratioUSDToUserCur;
						userCurExRates.userCurSymbol = assets[item].userCurSymbol;	
						userCurExRates.userCurrency = assets[item].userCurrency;					
					} else {
						/* User Assets */
						var mockUserAsset = assets[item];
						userassets.push(mockUserAsset);
					}
				}
			}
			resolve();
		});
	});
}


var preventAssetCreation = false;
function askCreateAlertForAsset(coreAssetId){
	var assetIndex = -1;
	for (var i = 0; i < userassets.length; i++){
		if (userassets[i] && userassets[i].core_asset_id == coreAssetId){
			assetIndex = i;
			break;
		}
	}
	if (assetIndex < 0) return;

	var buttons =[
		{action: "abort", title: I18n['dialogue_reject_trade_deletion']},
		{action: "save", title: I18n['dialogue_confirm_trade_deletion']}
	];
	wadialog(
		I18n['create_alert_after_asset_header'],
		I18n['create_alert_after_asset_text'],
		buttons, 
		openCreateAlertForAsset,
		null,
		assetIndex,
		true,
		true,
		'create-alert-after-asset-dialog'
	);
}

function openCreateAlertForAsset(assetIndex){
	var dialog_html = template_createAlert_dialog;
	var buttons =[
		{action: "abort", title: I18n["button_abort"]},
		{action: "save", title: I18n["button_create_alert"]}
	];
	dialog_html = dialog_html.replace("{{show_search_area}}", "none");
	wadialog(I18n["create_asset_for_existing_header"], dialog_html, buttons, createAlert, registerCreateExtraAlertEvents,{assetid: assetIndex} )
}

export function createAsset() {
	//$.ajax({type: 'POST',url: "/create_user_asset", data: "&asset%5Bstockname%5D=name&asset%5Bcore_asset_id%5D=12222&asset%5Buser_asset_startprice%5D=ert&asset%5Buser_asset_amount%5D=12dd"})
	return new Promise(function (resolve, reject) {
		feedbackProcessingDialog();
		var data_url = '';
		var errors = [];
		if (!validate_notEmptyString($('#alert_stockid').html())) errors.push({ code: '001', obj: $('#searchstring') });
			if (errors.length == 0) {				
			data_url += '&asset%5Bcore_asset_id%5D=' + selectors.getSelectedAsset();
		}
		else {
			removeAllErrorToolTips();
			showErrorToolTips(errors, errorcodes);
		}
		if (!errors.length && !preventAssetCreation) {
			preventAssetCreation = true;
			setTimeout(function () {
				$('.waiting-for-asset-box').remove();
				$("<div class='waiting-for-asset-box'><h5>" +I18n['wait_header']+ '</h5>' +I18n['wait_dialog']+'</div>').insertBefore('#searcharea');
			}, 5000);
			$.ajax({
				type: 'POST',
				url: '/create_user_asset',
				data: data_url,
				statusCode: {
					500: function () {
						alert('Server Error, sorry, we be right back!');
						preventAssetCreation = false;
						killProcessingDialog();
					},
					404: function () {
						alert('Portfolio-asset does not exist anymore!');
						preventAssetCreation = false;
						killProcessingDialog();
					},
				},
				success: function (response) {
					if (response.success) {
						preventAssetCreation = false;
						$('body,html').toggleClass('wait');
						BootstrapDialog.closeAll();
						var createdCoreAssetId = selectors.getSelectedAsset();
						scrollToAsset = createdCoreAssetId;
						pageRefresh(true).then(function(){
							if (!response.already_existed) askCreateAlertForAsset(createdCoreAssetId);
						})
						resolve();
					} else {
						if (response.status == 402) {
							preventAssetCreation = false;
							killProcessingDialog();
							openPaymentDialog();
						}
					}
				},
				error: function (response) {
					preventAssetCreation = false;
					killProcessingDialog();
					reject();
				}
			});
		} else {
			killProcessingDialog();
			console.log(errors, preventAssetCreation);
			reject();
		}
	});
}


export function editAsset(id) {
	var preventAssetEdit = false;
	//$.ajax({type: 'PUT',url: "/update_asset",data: "&asset%5Basset_id%5D=abc&asset%5Buser_asset_startprice%5D=ert&asset%5Buser_asset_amount%5D=12dd"})
	return new Promise(function (resolve, reject) {
		var data_url = '';
		var errors = [];
		id = id.assetid;
		feedbackProcessingDialog();
		if (validate_decnum_orempty($('#myAssetStartPrice').val()) === false) { errors.push({ code: '004', obj: $('#myAssetStartPrice') }); } else { $('#myAssetStartPrice').val(validate_decnum_orempty($('#myAssetStartPrice').val())); }
		if (validate_decnum_orempty($('#myAssetAmount').val()) === false) { errors.push({ code: '005', obj: $('#myAssetAmount') }); } else { $('#myAssetAmount').val(validate_decnum_orempty($('#myAssetAmount').val())); }
		if (errors.length == 0) {
			data_url += '&asset%5Basset_id%5D=' + userassets[id].id;
			data_url += '&asset%5Buser_asset_startprice%5D=' + $('#myAssetStartPrice').val();
			data_url += '&asset%5Buser_asset_amount%5D=' + $('#myAssetAmount').val();			
		}
		else {
			removeAllErrorToolTips();
			showErrorToolTips(errors, errorcodes);			
		}
		var url = '';
		if (!errors.length) {
			preventAssetEdit = true;
			var url = '/update_asset';
			$.ajax({
				type: 'PUT',
				url: url,
				data: data_url,
				statusCode: {
					500: function () {
						alert('Server Error, sorry, we be right back!');
						preventAssetEdit = false;
						killProcessingDialog();
					},
					404: function () {
						alert('Portfolio-asset does not exist anymore!');
						preventAssetEdit = false;
						killProcessingDialog();
					},
				},
				success: function (response) {
					preventAssetEdit = false;
					$('body,html').toggleClass('wait');
					BootstrapDialog.closeAll();
					pageRefresh();
					resolve();
				},
				error: function (response) {
					preventAssetEdit = false;
					killProcessingDialog();
					reject();
				}
			});
		}
		else {
			killProcessingDialog();
			reject();
		}
	});
}

export function deleteAsset(id) {

	feedbackProcessingDialog();

	var identifier = userassets[id].id;
	var assetID = identifier;
	var data_url = 'id=' + assetID;

	$.ajax({
		type: 'GET',
		url: '/destroy_user_asset',
		data: data_url,
		statusCode: {
			500: function () {
				alert('Server Error, sorry, we be right back!');
				killProcessingDialog();
			},
			404: function () {
				alert('Portfolio-asset does not exist anymore!');
				killProcessingDialog();
			},
		},
		success: function (response) { $('body').toggleClass('wait'); BootstrapDialog.closeAll(); pageRefresh(true); },  //  
		error: function (response) { $('body').toggleClass('wait'); }
	});
}

export function getAssetDataForCoreAsset(core_asset_id) {
	var data_url = 'core_asset_id=' + core_asset_id;
	return new Promise(function (resolve, reject) {
		$.ajax({
			type: 'GET',
			url: '/asset_data_by_core_asset',
			data: data_url,
			statusCode: {
				500: function () {
					alert('Server Error, sorry, we be right back!');
					killProcessingDialog();
				},
				404: function () {
					alert('Portfolio-asset does not exist anymore!');
					killProcessingDialog();
				},
			},
			success: function (response) { resolve(response); },  //  
			error: function (response) { reject(response); }
		});
	});
}
function buildAlertPayload(alertObj){
      var payload = { core_asset_id: alertObj.core_asset_id, type: alertObj.type };
      if (alertObj.type === 'Alertdelta'){
          payload.timeframe = alertObj.timeframe;
          payload.delta = alertObj.delta;
      } else if (alertObj.type === 'Alertabsolute'){
          payload.absolutevalue = alertObj.absolutevalue;
          payload.lessthan = alertObj.lessthan;
      } else if (alertObj.type === 'Alertkpi') {
          payload.alert_on_avg_200 = alertObj.alert_on_avg_200;
          payload.alert_on_avg_50 = alertObj.alert_on_avg_50;
      }
      return payload;
  }

  function showCommunityInfo(message){
      BootstrapDialog.show({
          title: I18n['community_info_header'],
          message: message,
          closeByBackdrop: true,
          closeByKeyboard: true,
          buttons: [{
              label: I18n['button_ok'],
              cssClass: 'btn-info dialog-btn',
              action: function(dialog){ dialog.close(); }
          }]
      });
  }

  function buildAlertResultMessage(assetExisted, alertExisted){
      if (alertExisted) return I18n['community_alert_exists'];
      if (assetExisted) return I18n['community_alert_added_asset_existed'];
      return I18n['community_alert_and_asset_added'];
  }

  export function addCommunityAssetToPortfolio(dataObj){
      feedbackProcessingDialog();
      $.ajax({
          type: 'POST',
          url: '/create_user_asset',
          data: '&asset%5Bcore_asset_id%5D=' + dataObj.core_asset_id,
          success: function (response){
              if (response && response.success){
                  $('body,html').toggleClass('wait');
                  BootstrapDialog.closeAll();
                  if (typeof dataObj.onDone === 'function') dataObj.onDone();
                  showCommunityInfo(response.already_existed ? I18n['community_asset_exists'] : I18n['community_asset_added']);
              } else if (response && response.status == 402){
                  killProcessingDialog();
                  openPaymentDialog();
              } else {
                  killProcessingDialog();
              }
          },
          error: function(){ killProcessingDialog(); }
      });
  }

  export function addCommunityAlertToPortfolio(dataObj){
      var alertObj = dataObj.alert;
      feedbackProcessingDialog();
      $.ajax({
          type: 'POST',
          url: '/create_user_asset',
          data: '&asset%5Bcore_asset_id%5D=' + alertObj.core_asset_id,
          success: function (assetResp){
              if (!assetResp || !assetResp.success){
                  if (assetResp && assetResp.status == 402) openPaymentDialog();
                  killProcessingDialog();
                  return;
              }
              var assetExisted = !!assetResp.already_existed;
              httpRequest('post', 'alerts', [ buildAlertPayload(alertObj) ])
                  .then(function (alertResp){
                      $('body,html').toggleClass('wait');
                      BootstrapDialog.closeAll();
                      if (typeof dataObj.onDone === 'function') dataObj.onDone();
                      var alertExisted = !!(alertResp && alertResp.already_existed);
                      showCommunityInfo(buildAlertResultMessage(assetExisted, alertExisted));
                  })
                  .catch(function (err){
                      if (err && err.status == 402) openPaymentDialog();
                      killProcessingDialog();
                  });
          },
          error: function(){ killProcessingDialog(); }
      });
  }
